
import { defineComponent, reactive, onMounted, toRefs } from "vue";
import { useRouter } from "vue-router";
import { config } from "@/Config";

export default defineComponent({
  name: "RecentChannels",
  components: {
    // ErrorList, // googleAuth
    // facebookLogin
  },
  props: {
    activity: Object,
  },
  setup(props) {
    const router = useRouter();
    const state = reactive({
      data: {
        imageBaseUrl: "",
      },
      ui: {
        postLoading: {
          processRegistration: false,
        },
      },
    });
    function redirectToChannel(form: any) {
      if(!form.uuid) return false
      router.push({
        name: "admin-channel",
        params: { channelId: form.uuid},
        query: { projectStatus: props.activity?.project_status_id }
      });
    }
    onMounted(() => {
      state.data.imageBaseUrl = config.imageBaseUrl;
    });
    return {
      redirectToChannel,
      ...toRefs(state),
    };
  },
});
